import clsx from 'clsx'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import { getFileKindLabel } from '@jotta/file-utils'
import { ItemKind } from '@jotta/grpc-js-client/fileService'
import type { PendingInvite } from '@jotta/grpc-web/no/jotta/openapi/sharing/v2/sharing.v2_pb'
import type { FileActionContext } from '@jotta/types/FileActions'
import SvgFillCaretDown from '@jotta/ui/SvgFillCaretDown'
import { cn } from '@jotta/utils/css'

import { fileActionApi } from '../FileActions/fileActionConfig'
import { FileContextMenu } from '../FileContextMenu/FileContextMenu'
import { getFileActionMenuItemsByContext } from '../FileContextMenu/getFileActionMenuItems'
import { FileIcon } from '../FileIcon/FileIcon'
import type { FolderStore } from '../Folder/FolderStore'

import styles from './PathItemRow.module.scss'

const debug = Debug('jotta:files:PathItemRow')
export interface PendingInviteRowProps {
  invite: PendingInvite.AsObject
  store: FolderStore
}
export const PendingInviteRow = observer<PendingInviteRowProps>(
  function PendingInviteRow({ invite, store }: PendingInviteRowProps) {
    const inviteKey = invite.inviteKey
    const acceptAction = fileActionApi.AcceptPendingInvite
    const actionContext: FileActionContext = 'PENDING_INVITE_LISTITEM'
    const viewMode = store.route.viewMode
    return (
      <div
        title={invite.name}
        className={clsx(styles.row, styles.pendingInviteRow)}
      >
        <div className={styles.checkbox} />
        <div className={cn(styles.rowDataWrapper, 'opacity-50')}>
          <div className={styles.rowData}>
            <div className={styles.icon}>
              <FileIcon kind={ItemKind.COLLABORATION_FOLDER} />
            </div>
            <span className={styles.link}>
              <p className={styles.linkInvite}>
                <span>{invite.name}</span>
                <small>
                  {' '}
                  (<Trans>Waiting for you to join...</Trans>)
                </small>
              </p>
            </span>
            <span className={styles.date}>-</span>
            <span className={styles.size}>-</span>
            <span className={styles.type}>
              {getFileKindLabel(ItemKind.COLLABORATION_FOLDER)}
            </span>
          </div>
        </div>

        <div
          className={cn('flex items-center justify-end', {
            'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2':
              viewMode === 'thumbs',
          })}
        >
          <FileContextMenu
            onSelect={store.actions.onContextMenuSelect}
            context={actionContext}
            path={inviteKey}
            triggerClassName={cn('btn btn-primary !flex !py-0')}
            actions={getFileActionMenuItemsByContext('PENDING_INVITE_LISTITEM')}
          >
            {acceptAction.name}
            <SvgFillCaretDown />
          </FileContextMenu>
        </div>
      </div>
    )
  },
)
